export const getBikes = (booking) => {
    let bikes = 0;
    if(booking.travellers !== null && typeof booking.travellers !== "undefined"){
        for(let i = 0, l = booking.travellers.length; i < l; i++) {
            // eslint-disable-next-line no-prototype-builtins
            if(booking.travellers[i].hasOwnProperty('bike') && booking.travellers[i].bike !== null) {
                bikes++;
            }
        }
    }

    return bikes;
};